import React from 'react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';

interface ShellPlaceholderActionsProps {
  className?: string;
}

export function ShellPlaceholderActions({ className }: ShellPlaceholderActionsProps) {
  const { toast } = useToast();

  const comingSoon = (label: string) => {
    toast({
      title: 'Coming soon',
      description: `${label} is not available yet.`,
    });
  };

  return (
    <div className={cn('flex items-center justify-end gap-2', className)}>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-10 rounded-full border-[var(--rcm-color-border)] bg-[var(--rcm-color-surface)] px-4 text-sm font-medium text-foreground shadow-none hover:bg-[var(--rcm-color-sidebar)]"
        onClick={() => comingSoon('Upgrade Plan')}
      >
        Upgrade Plan
      </Button>
    </div>
  );
}
